import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Handler from "../../../Helpers/Handler";
import MainLayout from "../../../Partials/MainLayout";
import FeedLayout from "../../../Partials/FeedLayout";

const MyCommunities = () => {
  const navigate    = useNavigate();
  const currentUser = useSelector((s) => s.customer?.customer?.user);

  const [list,    setList]    = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState("");

  useEffect(() => {
    const fetchCommunities = async () => {
      const res = await Handler({ method: "GET", url: "/communities/my_communities.php" });
      setLoading(false);
      if (res.success) setList(res.data?.list || []);
      else setError(res.message || "Failed to load communities.");
    };
    fetchCommunities();
  }, []);

  return (
    <MainLayout>
      <FeedLayout>
        <div className="mc-page">

          {/* Header — no create button, already in sidebar */}
          <div className="mc-top-header">
            <div>
              <h2 className="mc-title">My Communities</h2>
              <p className="mc-subtitle">Communities you have joined or created</p>
            </div>
          </div>

          {/* Error */}
          {error && (
            <div className="comm-alert error">
              <i className="bx bx-error-circle" /> {error}
            </div>
          )}

          {/* Loading */}
          {loading ? (
            <div className="mc-loading-wrap">
              <div className="mc-spinner" />
              <p>Loading your communities…</p>
            </div>

          /* Empty — just a message, no create button */
          ) : list.length === 0 ? (
            <div className="mc-empty-card">
              <div className="mc-empty-icon">
                <i className="bx bx-group" />
              </div>
              <h3>No Communities Yet</h3>
              <p>You have not joined any community. Use <strong>Create Community</strong> from the sidebar to get started.</p>
            </div>

          /* Grid */
          ) : (
            <div className="mc-grid">
              {list.map((c) => {
                const isCreator = parseInt(c.created_by) === parseInt(currentUser?.id);
                const initials  = c.name?.slice(0, 2).toUpperCase() || "CO";

                return (
                  <div key={c.id} className="mc-card">

                    {/* Avatar + Name + Badges */}
                    <div className="mc-card-top">
                      <div className={`mc-avatar mc-avatar--${c.type?.toLowerCase()}`}>
                        {initials}
                      </div>
                      <div className="mc-card-info">
                        <div className="mc-card-name">{c.name}</div>
                        <div className="mc-card-meta">
                          <span className={`mc-badge-type mc-badge-type--${c.type?.toLowerCase()}`}>
                            <i className={`bx ${c.type === "EVENT" ? "bx-calendar-event" : "bx-briefcase"}`} />
                            {c.type?.charAt(0) + c.type?.slice(1).toLowerCase()}
                          </span>
                          <span className={`mc-badge-role mc-badge-role--${c.role?.toLowerCase()}`}>
                            {c.role?.charAt(0) + c.role?.slice(1).toLowerCase()}
                          </span>
                          {isCreator && (
                            <span className="mc-badge-creator">
                              <i className="bx bx-crown" /> Creator
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Description */}
                    {c.description && (
                      <p className="mc-card-desc">{c.description}</p>
                    )}

                    {/* Stats */}
                    <div className="mc-card-stats">
                      <div className="mc-stat">
                        <i className="bx bx-group" />
                        <span>{c.total_members} Member{c.total_members !== 1 ? "s" : ""}</span>
                      </div>
                      <div className="mc-stat">
                        <i className="bx bx-shield-check" />
                        <span className={`mc-status mc-status--${c.status?.toLowerCase()}`}>
                          {c.status?.charAt(0) + c.status?.slice(1).toLowerCase()}
                        </span>
                      </div>
                    </div>

                    <div className="mc-divider" />

                    {/* Actions */}
                    <div className="mc-card-actions">
                      <button
                        className="mc-action-btn mc-action-btn--primary"
                        onClick={() => navigate("/user/community-chat", {
                          state: { community_id: c.id, community_name: c.name }
                        })}
                      >
                        <i className="bx bx-chat" /> Chat
                      </button>

                      <button
                        className="mc-action-btn mc-action-btn--outline"
                        onClick={() => navigate("/user/community-members", {
                          state: { community_id: c.id, community_name: c.name, is_creator: isCreator }
                        })}
                      >
                        <i className="bx bx-group" /> Members
                      </button>

                      {isCreator && (
                        <button
                          className="mc-action-btn mc-action-btn--ghost"
                          onClick={() => navigate("/user/edit-community", {
                            state: { community: c }
                          })}
                        >
                          <i className="bx bx-edit" /> Edit
                        </button>
                      )}
                    </div>

                  </div>
                );
              })}
            </div>
          )}

        </div>
      </FeedLayout>
    </MainLayout>
  );
};

export default MyCommunities;